import { Controller } from "react-hook-form";
import { Text } from "../index";
import { fontSizes } from "../../constants/constants";
import { IoMdClose } from "react-icons/io";
import Functions from "./index.function";
const PhoneNumberInput = ({
  control,
  name,
  label,
  defaultValue = "",
  countryCode = "",
  errors,
  setCountryCode,
  cca2 = "",
  setCca2,
  isMandatory,
  disabled = false,
}) => {
  const {
    selectedCountry,
    setSelectedCountry,
    phoneDigits,
    setPhoneDigits,
    inputValue,
    setInputValue,
    showDropdown,
    setShowDropdown,
    filteredCountries,
    handleInputChange,
    selectCountry,
    TextWeight,
    Countries,
  } = Functions(defaultValue, countryCode, setCountryCode, cca2, setCca2);
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={
        disabled
          ? {}
          : {
              required: `${label} is required`,
              validate: (value) => {
                if (selectedCountry && !phoneDigits) {
                  return "Please enter a phone number";
                }
                if (selectedCountry && phoneDigits.length < 10) {
                  return "Phone number is too short";
                }
                return true;
              },
            }
      }
      render={({ field: { onChange, value } }) => (
        <div className="relative">
          {/* Label */}
          {label && (
            <Text
              text={<>{label}</>}
              size={fontSizes.h16}
              weight={TextWeight.Onest_regular}
              isRequired={isMandatory}
              color="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary"
            />
          )}
          {/* Input Field */}
          <div className="relative">
            <input
              className={`xs:!mb-[2px] sm:mb-1 pl-12 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic ${
                disabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
              type="tel"
              disabled={disabled}
              value={
                selectedCountry
                  ? `${selectedCountry.dialCode} ${phoneDigits}`
                  : inputValue
              }
              onChange={(e) => handleInputChange(e.target.value, onChange)}
              onFocus={() => !disabled && !selectedCountry && setShowDropdown(true)}
              onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
              placeholder={selectedCountry ? "Phone number" : "Search country"}
            />

            {/* Country Flag */}
            <div
              className="absolute left-5 top-1/2 transform -translate-y-1/2"
              onClick={() => !disabled && setShowDropdown(true)}
            >
              {selectedCountry ? (
                <img
                  src={selectedCountry.flag}
                  alt={selectedCountry.name}
                  className="w-5 h-5"
                />
              ) : (
                <span className="text-sm text-white">🌐</span>
              )}
            </div>

            {/* Clear Button */}
            {selectedCountry && !disabled && (
              <button
                type="button"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
                onClick={() => {
                  setSelectedCountry(null);
                  setPhoneDigits("");
                  setInputValue("");
                  onChange("");
                }}
              >
                <IoMdClose className="text-xl text-secondary" />
              </button>
            )}
          </div>

          {/* Country Dropdown */}
          {showDropdown && !selectedCountry && inputValue ? (
            <div className="absolute left-0 top-full mt-2 z-10 w-full bg-[#171717] rounded-3xl max-h-60 overflow-y-auto scroll-container shadow-lg border-goldMetallic border-2 text-[#808080]">
              <ul>
                {filteredCountries.length > 0 ? (
                  filteredCountries.map((country) => (
                    <li
                      key={country.code}
                      className="xs:pl-3 sm:pl-5 py-2 lg:text-sm hover:bg-gray-700 flex items-center cursor-pointer"
                      onClick={() => selectCountry(country, onChange)}
                    >
                      <img
                        src={country.flag}
                        alt={country.name}
                        className="w-5 h-5 mr-2"
                      />
                      <span>
                        {country.name} ({country.dialCode})
                      </span>
                    </li>
                  ))
                ) : (
                  <div className="px-4 py-2 text-gray-400">
                    No matching countries found
                  </div>
                )}
              </ul>
            </div>
          ) : (
            <>
              {showDropdown && (
                <div className="absolute left-0 top-full mt-2 z-10 w-full bg-[#171717] rounded-3xl max-h-60 overflow-y-auto scroll-container shadow-lg border-goldMetallic border-2 text-[#808080]">
                  <ul>
                    {Countries?.map((country) => (
                      <li
                        key={country.code}
                        className="xs:pl-3 sm:pl-5 py-2 lg:text-sm hover:bg-gray-700 flex items-center cursor-pointer"
                        onClick={() => selectCountry(country, onChange)}
                      >
                        <img
                          src={country.flag}
                          alt={country.name}
                          className="w-5 h-5 mr-2"
                        />
                        <span>
                          {country.name} ({country.dialCode})
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}

          {/* Error Message */}
          {errors?.[name] && (
            <Text
              text={errors[name].message}
              color="text-orangeCrayola"
              size={fontSizes.h14}
              textWeight={TextWeight.Onest_regular}
              className={"xs:pl-6 sm:pl-6 lg:pl-8"}
              isTruncate={false}
            />
          )}
        </div>
      )}
    />
  );
};

export default PhoneNumberInput;